<!--
 * @Author:
 * @Description: 补采进度
-->
<template>
  <el-card class="h-full" :body-style="{ padding: '10px', height: '100%' }">
    <el-dialog
      v-dialogDrag
      title="补采进度"
      :visible.sync="dialogVisible"
      class="mini-dialog"
      custom-class="configure-dialog"
      :before-close="closeDialog"
    >
      <div class="h-full flex justify-center items-center">
        <el-progress type="circle" :percentage="collectionProgress"></el-progress>
      </div>
    </el-dialog>
  </el-card>
</template>

<script type="text/babel">
import configManagementService from '@/services/configManagementService'

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    progressKey: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  name: 'progess-dialog-visible',
  data() {
    return {
      collectionProgress: 0,
    }
  },
  computed: {},
  async mounted() {
    this.addProgress()
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },
    // 补采进度
    async addProgress() {
      const res = await configManagementService.getCollectHistoryDataProgress({
        key: this.progressKey,
      })
      if (res && res.code === 0) {
        this.collectionProgress = res.data
      }
    },
  },
}
</script>

<style lang="scss" scoped>

::v-deep .el-dialog__body {
  height: 100%;
}

</style>
